var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-web-console"},[_c('ButtonDropdown',{attrs:{"disabled":_vm.isOff,"no-drop":_vm.isOff,"button-label":"Console","dropdown-options":_vm.options,"size":"sm"},on:{"click-action":_vm.handleDropdown}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }